// removed by extract-text-webpack-plugin
module.exports = {"result":"result___3DYCz","icon":"icon___oXRn7","success":"success___3S1tt","error":"error___1On0m","title":"title___1oYaY","description":"description___2KDIR","extra":"extra___36IWh","actions":"actions___rlqmI"};


//////////////////
// WEBPACK FOOTER
// ./src/components/ant-design-pro/Result/index.less
// module id = 2UIb
// module chunks = 5 6 34 35 36 37 38 39 40